import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card } from "antd";
import Constants from "../Utils/Constants";
import { useTranslation } from "react-i18next";
import useToken from "../Authentication/useToken";
import axios from "axios";
import "./Styles.css";

const { Meta } = Card;

export default function Exercise({ exercise, onClick, onSelect }) {
  const { t } = useTranslation("Exercises");
  const { token } = useToken();

  const [bgUrl, setBgUrl] = useState(null);

  const { name, fitnessLevel, category, imageUrl } = exercise;

  const isMinioImageKey = (v) => typeof v === "string" && v.startsWith("images/");

  useEffect(() => {
    let cancelled = false;

    // 1) Pas d'image
    if (!imageUrl) {
      setBgUrl(null);
      return;
    }

    // 2) Nouveau cas: imageUrl = "images/...." (cl� MinIO)
    if (isMinioImageKey(imageUrl)) {
      axios
        .get(`${Constants.SERVER_URL}/api/minio/presign-download`, {
          params: {
            bucket: "rxapa-assets", // ?? ton bucket d�images
            key: imageUrl,         // ex: images/abc.jpg
          },
          headers: { Authorization: "Bearer " + token },
        })
        .then((res) => {
          if (!cancelled) setBgUrl(res.data.downloadUrl);
        })
        .catch(() => {
          if (!cancelled) setBgUrl(null);
        });

      return () => {
        cancelled = true;
      };
    }

    // 3) Ancien cas (si tu as encore des "/images/...")
    if (imageUrl.startsWith("/images/")) {
      setBgUrl(`${Constants.SERVER_URL}${imageUrl}`);
      return;
    }

    // fallback
    setBgUrl(null);

    return () => {
      cancelled = true;
    };
  }, [imageUrl, token]);

  const handleCardClick = (event) => {
    onClick(event);
    onSelect(exercise);
  };

  return (
    <Card hoverable className="exercise-card" onClick={handleCardClick}>
      <div
        className="exercise-background"
        style={{ backgroundImage: bgUrl ? `url(${bgUrl})` : "none" }}
      />
      <div className="exercise-info">
        <Meta title={name} description={`${fitnessLevel} | ${category}`} />
      </div>
    </Card>
  );
}

Exercise.propTypes = {
  exercise: PropTypes.shape({
    imageUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    fitnessLevel: PropTypes.string,
    category: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};